module.exports = __webpack_public_path__ + "img/10.5797db35.png";